__turbopack_context__.v({
  "back_button": "_3wVdMG_back_button",
  "genre_submenu": "_3wVdMG_genre_submenu",
  "genres_button": "_3wVdMG_genres_button",
  "genres_submenu_open": "_3wVdMG_genres_submenu_open",
  "genres_toggle": "_3wVdMG_genres_toggle",
  "is_open": "_3wVdMG_is_open",
  "links": "_3wVdMG_links",
  "live_tv_icon": "_3wVdMG_live_tv_icon",
  "mobile_menu": "_3wVdMG_mobile_menu",
  "mobile_menu_genre_nav_link": "_3wVdMG_mobile_menu_genre_nav_link",
  "mobile_menu_inner": "_3wVdMG_mobile_menu_inner",
  "mobile_menu_user_image_initial": "_3wVdMG_mobile_menu_user_image_initial",
  "mobile_menu_wrapper": "_3wVdMG_mobile_menu_wrapper",
  "my_station_icon": "_3wVdMG_my_station_icon",
  "passport_compass": "_3wVdMG_passport_compass",
  "personal": "_3wVdMG_personal",
  "user_settings_submenu": "_3wVdMG_user_settings_submenu",
  "user_settings_submenu_button_title": "_3wVdMG_user_settings_submenu_button_title",
  "user_settings_submenu_open": "_3wVdMG_user_settings_submenu_open",
  "user_settings_toggle_button": "_3wVdMG_user_settings_toggle_button",
});
